import { render, staticRenderFns } from "./FuelTransactions.vue?vue&type=template&id=2da775b6&"
import script from "./FuelTransactions.vue?vue&type=script&lang=js&"
export * from "./FuelTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports